export default __webpack_public_path__ + "static/media/backArrowGreen.ebd84242.svg";